export const withPrefix = (name, prefix = null) => (prefix ? `${prefix}.${name}` : name);
